"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.skipRetryOnForbidden = exports.isForbiddenError = exports.isAxiosLikeError = exports.calculateUtilizationPercentage = exports.mbToGiB = exports.bytesToGiB = exports.bytesToKiBps = void 0;
exports.parseStep = parseStep;
exports.getManipulateType = getManipulateType;
exports.formatChartTime = formatChartTime;
exports.calculateChartInterval = calculateChartInterval;
exports.augmentResourceData = augmentResourceData;
exports.calculateChartTicks = calculateChartTicks;
var dayjs_1 = __importDefault(require("dayjs"));
var monitoring_1 = require("../constants/monitoring");
/**
 * Parses a Prometheus step string (e.g. "5m", "1h") into a numeric value and dayjs unit.
 */
function parseStep(step) {
    var match = step.match(/^(\d+)([mhd])$/);
    if (!match)
        return { value: 1, unit: 'day' };
    var value = parseInt(match[1], 10);
    var unitChar = match[2];
    var unit = unitChar === 'd' ? 'day' : unitChar === 'h' ? 'hour' : 'minute';
    return { value: value, unit: unit };
}
function getManipulateType(step) {
    return parseStep(step).unit;
}
function formatChartTime(time, timeDiff) {
    var timeString = typeof time === 'number' ? new Date(time).toISOString() : time;
    var index = timeDiff > monitoring_1.TIME_CONSTANTS.ONE_DAY ? 0 : 1;
    return timeString.split('T')[index];
}
function calculateChartInterval(step, timeDiff) {
    if (step === '1m') {
        return 0;
    }
    else if (step === '5m') {
        // 1d → ~288 points, tick every ~2h → skip 23
        return 23;
    }
    else if (step === '30m') {
        // 7d → ~336 points, tick every ~12h → skip 23
        return 23;
    }
    else if (step === '1h' && timeDiff <= monitoring_1.TIME_CONSTANTS.TWELVE_HOURS) {
        return 2;
    }
    else if (step === '1h' && timeDiff <= monitoring_1.TIME_CONSTANTS.ONE_DAY) {
        return 5;
    }
    else if (step === '1h') {
        return 23;
    }
    else if (step === '1d' && timeDiff <= monitoring_1.TIME_CONSTANTS.TWO_WEEKS) {
        return 2;
    }
    else {
        return 6;
    }
}
// Create augmented data with placeholders for all expected data points
function augmentResourceData(resources, startDate, endDate, step) {
    if (!resources || !startDate || !endDate)
        return resources;
    var _a = parseStep(step), stepValue = _a.value, stepUnit = _a.unit;
    // Create a map of existing data points by time
    var dataMap = new Map();
    resources.forEach(function (item) {
        var timeKey = item.time;
        if (stepUnit === 'day') {
            timeKey = "".concat(item.time.split('T')[0], "T00:00");
        }
        else if (stepUnit === 'hour') {
            var _a = __read(item.time.split('T'), 2), date = _a[0], time = _a[1];
            var hour = time.substring(0, 2);
            timeKey = "".concat(date, "T").concat(hour, ":00");
        }
        else if (stepUnit === 'minute' && stepValue > 1) {
            // Round to nearest step boundary for multi-minute steps (5m, 30m)
            var _b = __read(item.time.split('T'), 2), datePart = _b[0], timePart = _b[1];
            var _c = __read(timePart.split(':'), 2), hour = _c[0], min = _c[1];
            var minuteRounded = Math.floor(parseInt(min, 10) / stepValue) * stepValue;
            timeKey = "".concat(datePart, "T").concat(hour, ":").concat(String(minuteRounded).padStart(2, '0'));
        }
        dataMap.set(timeKey, item);
    });
    // Generate complete list of expected data points based on window size
    var start = (0, dayjs_1.default)(startDate);
    var end = (0, dayjs_1.default)(endDate);
    var result = [];
    // Align starting point to step boundary
    var current;
    if (stepUnit === 'day') {
        current = start.startOf('day');
    }
    else if (stepUnit === 'hour') {
        current = start.startOf('hour');
    }
    else {
        // For minute-based steps, round down to the nearest step boundary
        var minuteRounded = Math.floor(start.minute() / stepValue) * stepValue;
        current = start.minute(minuteRounded).second(0).millisecond(0);
    }
    while (current.isBefore(end) || current.isSame(end)) {
        var timeKey = current.format('MM/DDTHH:mm');
        if (dataMap.has(timeKey)) {
            // Use the step-boundary time key so all data points are aligned
            result.push(__assign(__assign({}, dataMap.get(timeKey)), { time: timeKey }));
        }
        else {
            result.push({
                time: timeKey,
                value: null
            });
        }
        // Move to next interval
        current = current.add(stepValue, stepUnit);
    }
    return result;
}
var MIN_TICK_SPACING_PX = 60;
function generateSubDayTicks(start, end, intervalMinutes) {
    var result = [];
    var current;
    if (intervalMinutes >= 60) {
        var intervalHours = intervalMinutes / 60;
        var alignedHour = Math.floor(start.hour() / intervalHours) * intervalHours;
        current = start.startOf('hour').hour(alignedHour);
    }
    else {
        var alignedMinute = Math.floor(start.minute() / intervalMinutes) * intervalMinutes;
        current = start.startOf('minute').minute(alignedMinute);
    }
    while (current.isBefore(start)) {
        current = current.add(intervalMinutes, 'minute');
    }
    while (current.isBefore(end) || current.isSame(end)) {
        result.push(current.format('MM/DDTHH:mm'));
        current = current.add(intervalMinutes, 'minute');
    }
    return result;
}
function generateDayTicks(start, end, intervalDays) {
    var result = [];
    var current = start.startOf('day').add(intervalDays, 'day');
    while (current.isBefore(end) || current.isSame(end)) {
        result.push(current.format('MM/DDTHH:mm'));
        current = current.add(intervalDays, 'day');
    }
    return result;
}
function calculateChartTicks(startDate, endDate, step, containerWidth) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    if (!startDate || !endDate)
        return [];
    var start = (0, dayjs_1.default)(startDate);
    var end = (0, dayjs_1.default)(endDate);
    var maxTicks = containerWidth
        ? Math.max(2, Math.floor(containerWidth / MIN_TICK_SPACING_PX))
        : Infinity;
    if (step === '1m') {
        try {
            for (var _e = __values([30, 60, 120]), _f = _e.next(); !_f.done; _f = _e.next()) {
                var intervalMin = _f.value;
                var ticks = generateSubDayTicks(start, end, intervalMin);
                if (ticks.length <= maxTicks)
                    return ticks;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return generateSubDayTicks(start, end, 120);
    }
    if (step === '5m') {
        try {
            for (var _g = __values([180, 360, 720]), _h = _g.next(); !_h.done; _h = _g.next()) {
                var intervalMin = _h.value;
                var ticks = generateSubDayTicks(start, end, intervalMin);
                if (ticks.length <= maxTicks)
                    return ticks;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return generateSubDayTicks(start, end, 720);
    }
    if (step === '30m') {
        try {
            for (var _j = __values([1, 2, 3]), _k = _j.next(); !_k.done; _k = _j.next()) {
                var intervalDays = _k.value;
                var ticks = generateDayTicks(start, end, intervalDays);
                if (ticks.length <= maxTicks)
                    return ticks;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return generateDayTicks(start, end, 3);
    }
    if (step === '1h') {
        var diffDays = end.diff(start, 'day');
        var niceIntervalDays = diffDays <= 14 ? [2, 4, 7, 14] : [7, 14, 30];
        try {
            for (var niceIntervalDays_1 = __values(niceIntervalDays), niceIntervalDays_1_1 = niceIntervalDays_1.next(); !niceIntervalDays_1_1.done; niceIntervalDays_1_1 = niceIntervalDays_1.next()) {
                var d = niceIntervalDays_1_1.value;
                var ticks = generateDayTicks(start, end, d);
                if (ticks.length <= maxTicks)
                    return ticks;
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (niceIntervalDays_1_1 && !niceIntervalDays_1_1.done && (_d = niceIntervalDays_1.return)) _d.call(niceIntervalDays_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return generateDayTicks(start, end, niceIntervalDays[niceIntervalDays.length - 1]);
    }
    return null;
}
// Utility functions for data conversion
var bytesToKiBps = function (byteValue) {
    // Convert bytes/s to KiB/s (KB/s, treating KiB and KB as equivalent with base 1000)
    var kibps = byteValue / 1000;
    return parseFloat(kibps.toFixed(3));
};
exports.bytesToKiBps = bytesToKiBps;
var bytesToGiB = function (byteValue) {
    // Convert bytes to GiB/GB (treating GiB and GB as equivalent with base 1000)
    var gib = byteValue / 1073741824;
    return parseFloat(gib.toFixed(3));
};
exports.bytesToGiB = bytesToGiB;
var mbToGiB = function (mbValue) {
    // Convert MB to GiB/GB (treating GiB and GB as equivalent with base 1000)
    var gib = mbValue / 1000;
    return parseFloat(gib.toFixed(3));
};
exports.mbToGiB = mbToGiB;
// Calculate utilization percentage
var calculateUtilizationPercentage = function (usedValue, limitValue) {
    if (!limitValue || limitValue <= 0)
        return 0;
    var percentage = (usedValue / limitValue) * 100;
    return parseFloat(percentage.toFixed(2));
};
exports.calculateUtilizationPercentage = calculateUtilizationPercentage;
// Type guard for axios-like errors with response.status
var isAxiosLikeError = function (err) {
    return typeof err === 'object' &&
        err !== null &&
        'response' in err &&
        typeof err.response === 'object' &&
        err.response !== null &&
        'status' in err.response;
};
exports.isAxiosLikeError = isAxiosLikeError;
// Check if an error represents a 403 Forbidden response
var isForbiddenError = function (isError, error) {
    return isError && (0, exports.isAxiosLikeError)(error) && error.response.status === 403;
};
exports.isForbiddenError = isForbiddenError;
// Custom retry function that skips retries on 403
var skipRetryOnForbidden = function (failureCount, error) {
    if ((0, exports.isAxiosLikeError)(error) && error.response.status === 403)
        return false;
    return failureCount < 3;
};
exports.skipRetryOnForbidden = skipRetryOnForbidden;
